var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 7.825L6.10011 12.725C5.90011 12.925 5.66678 13.0208 5.40011 13.0125C5.13344 13.0042 4.90011 12.9 4.70011 12.7C4.51678 12.5 4.42094 12.2667 4.41261 12C4.40428 11.7333 4.50011 11.5 4.70011 11.3L11.3001 4.7C11.4001 4.6 11.5084 4.52917 11.6251 4.4875C11.7418 4.44584 11.8668 4.425 12.0001 4.425C12.1334 4.425 12.2584 4.44584 12.3751 4.4875C12.4918 4.52917 12.6001 4.6 12.7001 4.7L19.3001 11.3C19.4834 11.4833 19.5751 11.7125 19.5751 11.9875C19.5751 12.2625 19.4834 12.5 19.3001 12.7C19.1001 12.9 18.8626 13 18.5876 13C18.3126 13 18.0751 12.9 17.8751 12.7L13.0001 7.825V19C13.0001 19.2833 12.9043 19.5208 12.7126 19.7125C12.5209 19.9042 12.2834 20 12.0001 20C11.7168 20 11.4793 19.9042 11.2876 19.7125C11.0959 19.5208 11.0001 19.2833 11.0001 19V7.825Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow_up.10f79d7f3842cc25982fd856b5650dde.svg";
export { ForwardRef as ReactComponent };